import { beforeEnterHasPerm } from '@/components/PermissionHelper'

const beforeEnter = (to, from, next) => { return beforeEnterHasPerm(to, from, next) }

const ROUTES = {
  ATECO_CODE_LIST: 'miscellaneous-ateco-code'
}

const routes = [
  {
    path: 'ateco-code/',
    name: ROUTES.ATECO_CODE_LIST,
    beforeEnter: beforeEnter,
    meta: {
      permissions: ['miscellaneous_atecocode_list'],
      requiresAuth: true
    },
    component: () => import('./AtecoCodeList.vue')
  }

]

export { routes, ROUTES }
